import { useContext } from 'react';
import { PageContext } from '../../../api/PageContext';
import FormField from '../FormField';

const LanguageSelector = ({ value, onChange }) => {
  const { available_locales = [] } = useContext(PageContext);

  const options = available_locales.map(locale => ({
    value: locale.language_code,
    label: locale.language_name,
  }));

  return (
    <FormField
      as="select"
      name="language"
      label="Language"
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Select a language"
    />
  );
};

export default LanguageSelector;